import { useAppSelector, useDataLoad } from 'hooks';
import { isDefined } from 'utils';

import { LoadingSelector, SectionLoaderConfig } from './types';

type UseSectionLoaderWidget = {
  isVisible: boolean;
  isLoading: boolean;
  sectionTypeCode: string;
  hasData: boolean;
  isDisabled?: boolean;
};

const useRequestLoadingStatus = (loadingSelectors: LoadingSelector[]) => {
  const selectorsResult = loadingSelectors.map((selector) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { loading, requestCache } = useAppSelector(selector);
    return loading || !isDefined(requestCache);
  });

  return selectorsResult.some(Boolean);
};

const useSectionLoader = (loaderConfig: SectionLoaderConfig) => {
  const sectionWidgets = loaderConfig.map((configItem): UseSectionLoaderWidget => {
    const { subsectionTypeCode, requests, loadingSelector, dataSelector, useWidgetVisibility, isDisabled } = configItem;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const widgetVisibility = useWidgetVisibility();

    const isVisible = widgetVisibility.isWidgetVisible;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useDataLoad({ shouldLoad: isVisible && !isDisabled, requests });

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isRequestLoading = useRequestLoadingStatus(
      Array.isArray(loadingSelector) ? loadingSelector : [loadingSelector],
    );
    const isLoading = isVisible && isRequestLoading;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const hasData = useAppSelector(dataSelector);

    return {
      isVisible,
      isLoading,
      sectionTypeCode: subsectionTypeCode,
      hasData,
      isDisabled,
    };
  });

  const filteredSectionWidgets = sectionWidgets.filter((widget) => !widget.isDisabled && widget.isVisible);

  return filteredSectionWidgets;
};

export default useSectionLoader;
